import React from 'react';
import { clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { RfqDetailData } from '@routes/Common/type';
import { Box, makeStyles } from '@material-ui/core';
import { useStylesCommon } from './useStyles';

const useStyles = makeStyles(() => {
  return {
    root: {
      whiteSpace: 'pre-line',
      '& .rfq-detail-detailedRequest': {
        wordBreak: 'unset'
      }
    }
  };
});

interface Props {
  data?: RfqDetailData;
  matches?: boolean;
}

const RfqDetailedRequestPresenter: React.FC<Props> = ({ data, matches }) => {
  const classes = useStyles({ matches: matches });
  const classesCommon = useStylesCommon({ matches: matches });
  const detailedRequest = data?.detailedRequest;

  return (
    <Box className={clsx(classesCommon.root, classes.root, 'item')}>
      <CustomizedTypography
        variant={'h4'}
        color="textPrimary"
        fontWeight="500"
        gutterBottoms={16}
      >
        상세 요청사항
      </CustomizedTypography>
      {detailedRequest ? (
        <CustomizedTypography
          variant={'body1'}
          color="textPrimary"
          className={clsx([
            'rfq-detail-detailedRequest',
            classesCommon.wordBreak
          ])}
        >
          {detailedRequest}
        </CustomizedTypography>
      ) : (
        <CustomizedTypography variant={'body1'} color="textSecondary">
          상세 요청사항이 없어요.
        </CustomizedTypography>
      )}
    </Box>
  );
};

export default RfqDetailedRequestPresenter;
